import 'twin.macro';
import React from 'react';

export function Tick({ tick, count }) {
  return (
    <div>
      <div
        tw="absolute mt-[52px] -ml-[0.5px] w-[1px] h-2 bg-neutral-quiet"
        style={{
          left: `${tick.percent}%`,
        }}
      />
      <div
        tw="absolute mt-[60px] text-[10px] text-center"
        style={{
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
        }}
      >
        {tick.value}
      </div>
    </div>
  );
}
